import { useEffect } from "react";
import { Navigate, useLocation } from "react-router";
import { useAuth } from "src/context/AuthContext";
import { useAuthModal } from "src/context/AuthModalContext";

/**
 * Wraps a protected route. When the visitor is not authenticated, redirects
 * to "/" and opens the AuthModal in login mode. After a successful login,
 * AuthModal's own false→true effect fires the post-login redirect probe
 * (GET /api/pumppuRequests/mine/counts → /tilaa for drafts, /valut for sent
 * rows, else stay) — see the effect at the top of AuthModal.jsx.
 */
export default function RequireAuth({ children }) {
    const { isAuthenticated } = useAuth();
    const { openAuthModal } = useAuthModal();
    const location = useLocation();

    useEffect(() => {
        if (!isAuthenticated) {
            openAuthModal();
        }
    }, [isAuthenticated, openAuthModal]);

    if (!isAuthenticated) {
        return <Navigate to="/" replace state={{ from: location.pathname }} />;
    }
    return children;
}
